import { ApiListParams, ApiListResponse } from "../types/api.type";
import { api } from "../libs/baseApi";
import { Notification } from "../types/notification.type";

export const getNotifications = async (params: ApiListParams<any>) => {
  const response = await api.get<ApiListResponse<Notification>>(
    "/v1/vendor/notifications",
    {
      params,
    }
  );
  return response.data;
};

export const markNotificationsRead = async (ulids: string[]) => {
  const response = await api.post("/v1/vendor/notifications/read", { ulids });
  return response.data;
};

